import React, { Component } from 'react';
import { object, string, func, bool } from 'prop-types';
import classnames from 'classnames';
import { Interpolate, translate } from 'react-i18next';
import { inject, observer } from 'mobx-react';

import CloseBar from '../close-bar';
import FooterLayout from '../footer-layout';
import styles from './notification-modal-layout.scss';

import { Text, Loader, Heading } from 'wix-style-react';

class NotificationModalLayout extends Component {
  static propTypes = {
    view: object.isRequired,
    t: func.isRequired,
    title: string.isRequired,
    subTitle: string.isRequired,
    illustration: object.isRequired,
    onXClick: func.isRequired,
    isErrorNotification: bool,
    primaryButtonLabel: string,
    primaryButtonHeight: string,
    onPrimaryButtonClick: func,
    secondaryButtonLabel: string,
    onSecondaryButtonClick: func,
    onOpened: func,
    onClosed: func,
  };

  componentDidMount() {
    this.props.onOpened && this.props.onOpened();
  }

  componentWillUnmount() {
    this.props.onClosed && this.props.onClosed();
  }

  renderContent = () => {
    const {
      title,
      subTitle,
      illustration,
      primaryButtonLabel,
      primaryButtonHeight,
      onPrimaryButtonClick,
      secondaryButtonLabel,
      onSecondaryButtonClick,
      onXClick,
      t,
      isErrorNotification,
    } = this.props;

    return (
      <div>
        <CloseBar onClose={onXClick} />
        <div className={styles.header}>
          <div className={styles.illustration}>{illustration}</div>
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
            <Heading dataHook="notification-title" appearance="H2">
              {t(title)}
            </Heading>
          </div>

          <div className={styles[`sub-title`]}>
            <Text dataHook="notification-sub-title" secondary>
              <Interpolate i18nKey={subTitle} useDangerouslySetInnerHTML />
            </Text>
          </div>
        </div>
        <FooterLayout
          size="extra-large"
          primaryButtonLabel={t(primaryButtonLabel)}
          primaryButtonHeight={primaryButtonHeight}
          onPrimaryButtonClick={onPrimaryButtonClick}
          secondaryButtonLabel={t(secondaryButtonLabel)}
          onSecondaryButtonClick={onSecondaryButtonClick}
          theme={isErrorNotification ? 'error' : 'notification'}
        />
      </div>
    );
  };

  render() {
    const {
      view: { isModalLoading },
    } = this.props;
    return (
      <div
        data-hook="notification-modal"
        className={classnames(
          styles.container,
          isModalLoading && styles.loader,
        )}
      >
        {isModalLoading ? (
          <Loader dataHook="notification-modal-loader" />
        ) : (
          this.renderContent()
        )}
      </div>
    );
  }
}

export default translate()(inject('view')(observer(NotificationModalLayout)));
